import React, { ComponentType, PureComponent } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { changeDeparture, changeArrival } from '../actions/booking';
import { fetchTripInfos, setTripStatus, clearTripInfos } from '../actions/trip';
import { Trip } from '../../booking/model';
import type { FormContent } from './Form';
import type { State } from '../reducers';
import { Api } from '../../common/model';

interface TripState {
  start: Trip;
  end: Trip;
}

type Prefix = 'start' | 'end';

interface Props {
  sites: Array<Api.Site>;
  switches: Array<Api.SiteSwitch>;
  departure: FormContent;
  departureSlots?: Api.SiteSlots;
  arrival: FormContent;
  arrivalSlots?: Api.SiteSlots;
  isFetchingDepartureSlots: boolean;
  isFetchingArrivalSlots: boolean;
  trip: TripState;
  changeDeparture: (departure: FormContent, forceSameSite: boolean) => void;
  changeArrival: (arrival: FormContent) => void;
  fetchTripInfos: (prefix: Prefix, site: string, date: string, tripNumber: string, signal?: any) => void;
  setTripStatus: (prefix: Prefix, status: import('../model').TripStatus) => void;
  clearTripInfos: (prefix: Prefix) => void;
}

const mapStateToProps = (state: State) => ({ ...state.booking, trip: { ...state.trip } });

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      changeDeparture,
      changeArrival,
      fetchTripInfos,
      setTripStatus,
      clearTripInfos,
    },
    dispatch,
  );

export const withOrder = (WrappedComponent: ComponentType<any>) => {
  class WithOrder extends PureComponent<Props> {
    static displayName = 'HOC(WithOrder)';

    render() {
      const {
        departure,
        departureSlots,
        changeDeparture,
        arrival,
        arrivalSlots,
        changeArrival,
        isFetchingDepartureSlots,
        isFetchingArrivalSlots,
        trip,
        fetchTripInfos,
        setTripStatus,
        clearTripInfos,
      } = this.props;

      const tripActions = {
        fetchTripInfos,
        setTripStatus,
        clearTripInfos,
      };

      return (
        <WrappedComponent
          {...this.props}
          departure={departure}
          departureSlots={departureSlots}
          onDepartureChanged={changeDeparture}
          isFetchingDepartureSlots={isFetchingDepartureSlots}
          arrival={arrival}
          arrivalSlots={arrivalSlots}
          onArrivalChanged={changeArrival}
          isFetchingArrivalSlots={isFetchingArrivalSlots}
          trip={trip}
          tripActions={tripActions}
        />
      );
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithOrder);
};
